export default __webpack_public_path__ + "static/Padauk-Regular-805d8456e6fca6617f43679bc38d3b4c.ttf";